import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import TransactionsList from '../views/TransactionsList.vue'
import ImportTransactionsView from '../views/ImportTransactionsView.vue'
import BudgetView from '../views/BudgetView.vue'
import CategoryRulesPage from "@/views/CategoryRulesPage";
import LoginPage from "@/views/LoginPage";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/transactions',
        name: 'transactions_list',
        component: TransactionsList
    },
    {
        path: '/import',
        name: 'import_transactions_view',
        component: ImportTransactionsView
    },
    {
        path: '/budget',
        name: 'budget_view',
        component: BudgetView
    },
    {
        path: '/category_rules_view',
        name: 'category_rules_view',
        component: CategoryRulesPage
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage
    }
]

const router = new VueRouter({
    routes
})

export default router